(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bunnings-carousel"] && !Shopify.designMode) return;
  try {
    
  class BunningsCarouselSlider {
    constructor(container, section) {
      this.container = container;
      this.section = section;
      this.items = container.querySelector('.bunnings-carousel__items');
      this.prevButton = container.querySelector('.bunnings-carousel__nav-button--prev');
      this.nextButton = container.querySelector('.bunnings-carousel__nav-button--next');
      this.dotsContainer = container.querySelector('.bunnings-carousel__dots');
      this.dots = Array.from(container.querySelectorAll('.bunnings-carousel__dot'));
      this.selectedDotIndex = null;
      this.lightbox = section.querySelector('.bunnings-carousel__lightbox');
      this.lightboxImage = section.querySelector('.bunnings-carousel__lightbox-image');
      this.lightboxClose = section.querySelector('[data-lightbox-close]');
      this.lightboxTriggers = Array.from(container.querySelectorAll('[data-lightbox-trigger]'));

      if (!this.items) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollPrev());
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollNext());
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollToDotIndex(Number(dot.dataset.dotIndex)));
      });
      this.lightboxTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.openLightbox(trigger));
      });
      if (this.lightboxClose) this.lightboxClose.addEventListener('click', () => this.closeLightbox());
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (event) => {
          if (event.target === this.lightbox) this.closeLightbox();
        });
      }

      const onScroll = () => this.updateControls();
      this.items.addEventListener('scroll', onScroll, { passive: true });
      this.items.addEventListener('touchmove', onScroll, { passive: true });
      this.items.addEventListener('touchstart', () => this.clearSelectedDotIndex(), { passive: true });
      this.items.addEventListener('wheel', () => this.clearSelectedDotIndex(), { passive: true });

      this.updateControls();
      window.addEventListener('resize', () => {
        setTimeout(() => this.updateControls(), 100);
      });
    }

    scrollPrev() {
      this.scrollByItem(-1);
    }

    scrollNext() {
      this.scrollByItem(1);
    }

    getItems() {
      return Array.from(this.items.querySelectorAll('.bunnings-carousel__item'));
    }

    getCurrentIndex(list) {
      if (!list.length) return 0;
      const scrollLeft = this.items.scrollLeft;

      let closestIndex = 0;
      let smallestDistance = Number.POSITIVE_INFINITY;

      list.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    scrollByItem(direction) {
      const list = this.getItems();
      if (!list.length) return;
      const currentIndex = this.getCurrentIndex(list);
      const targetIndex = Math.max(0, Math.min(list.length - 1, currentIndex + direction));
      const targetItem = list[targetIndex];
      if (!targetItem) return;
      this.selectedDotIndex = targetIndex;
      this.updateDots();
      this.items.scrollTo({ left: targetItem.offsetLeft, behavior: 'smooth' });
    }

    scrollToDotIndex(index) {
      const list = this.getItems();
      const item = list[index];
      if (!item) return;
      this.selectedDotIndex = index;
      this.updateDots();
      this.items.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }

    clearSelectedDotIndex() {
      this.selectedDotIndex = null;
    }

    updateDots() {
      if (!this.dots.length) return;
      const list = this.getItems();
      if (!list.length) return;
      const currentItemIndex = this.getCurrentIndex(list);
      const scrollIndex = Math.max(0, Math.min(this.dots.length - 1, currentItemIndex));
      const currentIndex = this.selectedDotIndex ?? scrollIndex;

      this.dots.forEach((dot, index) => {
        const isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    updateControls() {
      const scrollLeft = this.items.scrollLeft;
      const scrollable = this.items.scrollWidth - this.items.clientWidth;
      const isScrollable = scrollable > 1;
      const isDesktop = window.matchMedia('(min-width: 1280px)').matches;

      if (this.prevButton) {
        this.prevButton.disabled = scrollLeft <= 1;
        this.prevButton.style.display = isDesktop && isScrollable ? 'flex' : 'none';
      }

      if (this.nextButton) {
        this.nextButton.disabled = scrollLeft >= scrollable - 1;
        this.nextButton.style.display = isDesktop && isScrollable ? 'flex' : 'none';
      }

      if (this.dotsContainer) {
        this.dotsContainer.style.display = !isDesktop && isScrollable ? 'flex' : 'none';
      }

      this.updateDots();
    }

    openLightbox(trigger) {
      if (!this.lightbox || !this.lightboxImage) return;
      const src = trigger.dataset.lightboxSrc;
      if (!src) return;
      this.lightboxImage.src = src;
      this.lightboxImage.alt = trigger.dataset.lightboxAlt || '';
      this.lightbox.showModal();
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.close();
    }
  }

  function initBunningsCarousel() {
    document.querySelectorAll('.bunnings-carousel').forEach((section) => {
      const container = section.querySelector('.bunnings-carousel__slider-wrapper');
      if (!container) return;
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';
      new BunningsCarouselSlider(container, section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBunningsCarousel);
  else initBunningsCarousel();

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.bunnings-carousel').forEach((section) => {
        const container = section.querySelector('.bunnings-carousel__slider-wrapper');
        if (!container) return;
        container.dataset.initialized = '';
        new BunningsCarouselSlider(container, section);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunnings-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const backToTopButtons = document.querySelectorAll('.bunnings-footer__back-to-top');

    if (!backToTopButtons.length) {
      return;
    }

    backToTopButtons.forEach((button) => {
      button.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunnings-popular-products"] && !Shopify.designMode) return;
  try {
    
  class BunningsPopularProductsSlider {
    constructor(container) {
      this.products = container.querySelector('.bunnings-popular-products__products');
      this.prevButton = container.querySelector('.bunnings-popular-products__nav-button--prev');
      this.nextButton = container.querySelector('.bunnings-popular-products__nav-button--next');
      if (!this.products) return;
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollPrev());
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollNext());
      const handleScroll = () => this.updateButtonStates();
      this.products.addEventListener('scroll', handleScroll, { passive: true });
      this.products.addEventListener('touchmove', handleScroll, { passive: true });
      this.updateButtonStates();
      this.checkVisibility();
      window.addEventListener('resize', () => { setTimeout(() => { this.updateButtonStates(); this.checkVisibility(); }, 100); });
    }
    scrollPrev() { if (!this.products) return; this.products.scrollBy({ left: -(this.products.clientWidth * 0.8), behavior: 'smooth' }); }
    scrollNext() { if (!this.products) return; this.products.scrollBy({ left: this.products.clientWidth * 0.8, behavior: 'smooth' }); }
    updateButtonStates() {
      if (!this.products) return;
      const scrollLeft = this.products.scrollLeft, scrollable = this.products.scrollWidth - this.products.clientWidth;
      if (this.prevButton) this.prevButton.disabled = scrollLeft <= 1;
      if (this.nextButton) this.nextButton.disabled = scrollLeft >= scrollable - 1;
    }
    checkVisibility() {
      if (!this.products) return;
      const isScrollable = this.products.scrollWidth > this.products.clientWidth;
      if (this.prevButton) this.prevButton.style.display = isScrollable ? 'flex' : 'none';
      if (this.nextButton) this.nextButton.style.display = isScrollable ? 'flex' : 'none';
    }
  }
  function init() {
    document.querySelectorAll('.bunnings-popular-products__slider-wrapper').forEach(container => {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';
      new BunningsPopularProductsSlider(container);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      e.target.querySelectorAll('.bunnings-popular-products__slider-wrapper').forEach(container => {
        container.dataset.initialized = '';
        new BunningsPopularProductsSlider(container);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunnings-shop-by-category"] && !Shopify.designMode) return;
  try {
    
  class BunningsShopByCategorySlider {
    constructor(container) {
      this.container = container;
      this.categories = container.querySelector('.bunnings-shop-by-category__categories');
      this.prevButton = container.querySelector('.bunnings-shop-by-category__nav-button--prev');
      this.nextButton = container.querySelector('.bunnings-shop-by-category__nav-button--next');
      this.scrollIndicator = container.querySelector('.bunnings-shop-by-category__scroll-indicator');
      this.progressBar = container.querySelector('.bunnings-shop-by-category__scroll-progress');
      this.dragStartX = 0;
      this.dragStartScroll = 0;
      this.isDragging = false;
      if (!this.categories) return;
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollPrev());
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollNext());
      if (this.scrollIndicator) {
        this.scrollIndicator.addEventListener('click', (e) => this.onTrackClick(e));
      }
      if (this.progressBar) {
        this.progressBar.addEventListener('mousedown', (e) => this.startDrag(e));
        this.progressBar.addEventListener('touchstart', (e) => this.startDrag(e), { passive: false });
      }
      let rafId = null;
      const handleScroll = () => { if (rafId) return; rafId = requestAnimationFrame(() => { this.updateProgress(); this.updateButtonStates(); rafId = null; }); };
      this.categories.addEventListener('scroll', handleScroll, { passive: true });
      this.categories.addEventListener('touchmove', handleScroll, { passive: true });
      setTimeout(() => { this.updateProgress(); this.updateButtonStates(); this.checkVisibility(); }, 100);
      window.addEventListener('resize', () => { setTimeout(() => { this.updateProgress(); this.updateButtonStates(); this.checkVisibility(); }, 100); });
      const images = this.categories.querySelectorAll('img');
      if (images.length > 0) {
        let loadedCount = 0;
        images.forEach(img => {
          if (img.complete) loadedCount++;
          else img.addEventListener('load', () => { loadedCount++; if (loadedCount === images.length) setTimeout(() => { this.updateProgress(); this.updateButtonStates(); }, 50); });
        });
        if (loadedCount === images.length) setTimeout(() => { this.updateProgress(); this.updateButtonStates(); }, 50);
      }
    }
    onTrackClick(e) {
      if (e.target.closest('.bunnings-shop-by-category__scroll-progress')) return;
      if (!this.categories) return;
      const track = this.scrollIndicator || this.progressBar?.parentElement;
      if (!track) return;
      const scrollable = this.categories.scrollWidth - this.categories.clientWidth;
      if (scrollable <= 0) return;
      const rect = track.getBoundingClientRect();
      const clientX = e.clientX ?? e.touches?.[0]?.clientX ?? e.changedTouches?.[0]?.clientX ?? 0;
      const x = clientX - rect.left;
      const percent = Math.max(0, Math.min(1, x / rect.width));
      this.categories.scrollLeft = percent * scrollable;
    }
    startDrag(e) {
      if (!this.categories || !this.progressBar) return;
      const clientX = e.clientX !== undefined ? e.clientX : e.touches[0].clientX;
      this.isDragging = true;
      this.dragStartX = clientX;
      this.dragStartScroll = this.categories.scrollLeft;
      e.preventDefault();
      const onMove = (ev) => {
        if (!this.isDragging) return;
        const x = ev.clientX !== undefined ? ev.clientX : ev.touches[0].clientX;
        const scrollable = this.categories.scrollWidth - this.categories.clientWidth;
        if (scrollable <= 0) return;
        const trackRect = this.scrollIndicator ? this.scrollIndicator.getBoundingClientRect() : this.progressBar.parentElement.getBoundingClientRect();
        const deltaX = x - this.dragStartX;
        const deltaScroll = (deltaX / trackRect.width) * scrollable;
        this.categories.scrollLeft = Math.max(0, Math.min(scrollable, this.dragStartScroll + deltaScroll));
        this.dragStartX = x;
        this.dragStartScroll = this.categories.scrollLeft;
      };
      const onEnd = () => {
        this.isDragging = false;
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove, { passive: false });
        document.removeEventListener('touchend', onEnd);
      };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onEnd);
    }
    scrollPrev() { if (!this.categories) return; this.categories.scrollBy({ left: -(this.categories.clientWidth * 0.8), behavior: 'smooth' }); }
    scrollNext() { if (!this.categories) return; this.categories.scrollBy({ left: this.categories.clientWidth * 0.8, behavior: 'smooth' }); }
    updateProgress() {
      if (!this.categories || !this.progressBar) return;
      const scrollLeft = this.categories.scrollLeft;
      const scrollWidth = this.categories.scrollWidth;
      const clientWidth = this.categories.clientWidth;
      const scrollable = scrollWidth - clientWidth;
      if (scrollable <= 0) {
        this.progressBar.style.width = '100%';
        this.progressBar.style.left = '0';
        return;
      }
      const thumbWidthPercent = (clientWidth / scrollWidth) * 100;
      const thumbMaxTravel = 100 - thumbWidthPercent;
      const scrollPercent = (scrollLeft / scrollable) * 100;
      const leftPercent = (scrollPercent / 100) * thumbMaxTravel;
      this.progressBar.style.width = Math.max(2, thumbWidthPercent) + '%';
      this.progressBar.style.left = leftPercent + '%';
    }
    updateButtonStates() {
      if (!this.categories) return;
      const scrollLeft = this.categories.scrollLeft, scrollable = this.categories.scrollWidth - this.categories.clientWidth;
      const isScrollable = scrollable > 1;
      const isAtStart = scrollLeft <= 1;
      const isAtEnd = scrollLeft >= scrollable - 1;
      if (this.prevButton) {
        this.prevButton.disabled = isAtStart;
        this.prevButton.hidden = !(isScrollable && !isAtStart);
      }
      if (this.nextButton) {
        this.nextButton.disabled = isAtEnd;
        this.nextButton.hidden = !(isScrollable && !isAtEnd);
      }
      if (this.scrollIndicator) {
        this.scrollIndicator.hidden = !isScrollable;
      }
    }
    checkVisibility() {
      this.updateButtonStates();
    }
  }
  function initBunningsShopByCategorySliders() {
    document.querySelectorAll('.bunnings-shop-by-category__slider-wrapper').forEach(container => {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';
      new BunningsShopByCategorySlider(container);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBunningsShopByCategorySliders);
  else initBunningsShopByCategorySliders();
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.bunnings-shop-by-category__slider-wrapper').forEach(container => {
        container.dataset.initialized = '';
        new BunningsShopByCategorySlider(container);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-accordions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const REVIEWS_DETAILS_SELECTOR = '[data-testid="product-ratings-reviews-details"]';
    const INLINE_RATING_SELECTOR = '.bunnings-product-details__ratings-slot [data-bv-show="inline_rating"]';

    document.addEventListener(
      'click',
      (event) => {
        const target = /** @type {Element | null} */ (event.target instanceof Element ? event.target : null);
        if (!target) return;

        const inlineRating = target.closest(INLINE_RATING_SELECTOR);
        if (!inlineRating) return;

        const interactiveTarget = target.closest('a, button, [role="button"]');
        if (!interactiveTarget) return;

        const reviewsDetails = document.querySelector(REVIEWS_DETAILS_SELECTOR);
        if (!(reviewsDetails instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        event.stopPropagation();

        reviewsDetails.setAttribute('open', '');
        reviewsDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
